import { render, staticRenderFns } from "./core.vue?vue&type=template&id=52789a18&scoped=true&"
import script from "./core.ts?vue&type=script&lang=js&"
export * from "./core.ts?vue&type=script&lang=js&"
import style0 from "../assets/styles/common.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./core.scss?vue&type=style&index=1&id=52789a18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52789a18",
  null
  
)

export default component.exports